import { handleActions } from 'redux-actions'
import { fromJS, List } from 'immutable'

import * as Actions from 'actions/saved_searches'
import * as AppActions from 'actions/app'

export const initialState = fromJS([])

const membershipsOf = group => group.get('grootSavedSearchesSavedSearchGroups') || List()

export default handleActions({
  [Actions.setSavedSearches]: (state, { payload }) => fromJS(payload.savedSearchGroups || []),

  [Actions.saveSavedSearchGroupSuccess]: (state, { payload }) => {
    const group = fromJS(payload)
    const foundIndex = state.findIndex(item => item.get('id') === group.get('id'))

    if (foundIndex !== -1) {
      return state.set(foundIndex, group)
    }

    return state.push(group)
  },

  [Actions.deleteSavedSearchGroupSuccess]: (state, { payload: group }) => (
    state.filter(item => item.get('id') !== group.get('id'))
  ),

  [Actions.assignSavedSearchToGroupSuccess]: (state, { payload: { groupId, result } }) => state.map(group => {
    if (group.get('id') !== groupId) {
      return group
    }

    return group.update('grootSavedSearchesSavedSearchGroups', memberships => (
      (memberships || List()).push(fromJS(result))
    ))
  }),

  [Actions.removeSavedSearchFromGroupSuccess]: (state, { payload: { groupId, id } }) => state.map(group => {
    if (group.get('id') !== groupId) {
      return group
    }

    return group.set(
      'grootSavedSearchesSavedSearchGroups',
      membershipsOf(group).filterNot(membership => membership.get('id') === id)
    )
  }),

  [Actions.deleteSavedSearchSuccess]: (state, { payload: savedSearchId }) => state.map(group => (
    group.set(
      'grootSavedSearchesSavedSearchGroups',
      membershipsOf(group).filter(membership => membership.get('savedSearchId') !== savedSearchId)
    )
  )),

  [AppActions.resetState]: () => initialState
}, initialState)
